export default __webpack_public_path__ + "static/media/gallinaTtsIt_It60.18bce340.mp3";